<template>
  <div class="tgrade">
    <h3>Ведомость</h3>
    <div class="tgrade__filters">
      <div class="tgrade__filters-wrp">
        <span>Дисциплина</span>
        <el-select
          @change="changeDiscipline"
          v-model="filters.discipline"
          placeholder="Выберите дисциплину"
        >
          <el-option
            v-for="discipline in supportFilters.disciplineList"
            :key="discipline.value"
            :label="discipline.name"
            :value="discipline.discipline_id"
          >
          </el-option>
        </el-select>
      </div>

      <transition name="fade">
        <div v-if="filters.discipline" class="filters-right">
          <div class="tgrade__filters-wrp">
            <span>Группа</span>
            <el-select v-model="filters.group" placeholder="Выберите группу">
              <el-option
                v-for="group in supportFilters.groupList"
                :key="group.value"
                :label="group.name"
                :value="group.bill_id"
              >
              </el-option>
            </el-select>
          </div>
          <el-button @click="runFilter" type="primary" :disabled="filterReady"
            >Отфильтровать</el-button
          >
        </div>
      </transition>
    </div>

    <div v-if="supportFilters.resultData.length" class="tgrade__table">
      <div class="table-header">
        <div class="row">
          <el-input
            placeholder="Имя студента"
            v-model="filters.studentName"
          ></el-input>
          <span>Группа</span>
          <span>Явка</span>
          <span>Итоговая оценка</span>
        </div>
      </div>
      <div class="table__body">
        <div v-if="dateExam" class="row row-notify">
          <i class="el-icon-warning"></i>
          <p class="text-notify">
            Оценки могут быть выставлены в день экзамена "{{ dateExam }}" , либо
            после {{ examDatePlus14 }}.
          </p>
        </div>
        <div
          class="row"
          v-for="(resultSt, index) of filtredResultData()"
          :key="index"
        >
          <span>{{ resultSt.name }}</span>
          <span>{{ resultSt.groupName }}</span>
          <el-checkbox v-model="resultSt.attendance"></el-checkbox>
          <el-select
            :disabled="!resultSt.attendance"
            @change="saveResult(resultSt)"
            v-model="resultSt.finalGrades"
            placeholder="Выберите оценку"
          >
            <el-option
              v-for="(grade, index) of supportFilters.gradeList"
              :key="index"
              :label="grade === 'null' ? ' ' : grade"
              :value="grade"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <transition name="fade" v-if="emptyResult">
      <p class="empty-result">Нет данных</p>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Tgrade",
  data() {
    return {
      emptyResult: false,
      examDatePlus14: "",
      dateExam: "",
      filters: {
        group: "",
        discipline: "",
        studentName: "",
      },

      supportFilters: {
        gradeList: [],
        resultData: [],
        groupList: [],
        disciplineList: [],
        resultList: [],
      },
    };
  },
  computed: {
    filterReady() {
      return this.filters.group ? false : true;
    },
  },
  methods: {
    notify(status, text) {
      const h = this.$createElement;
      this.$notify({
        title: "",
        message: h(
          "i",
          { style: `color: ${status ? "#67C23A" : " #f56c6c"}` },
          text
        ),
      });
    },
    dateAfter(value) {
      value.split(".");
    },
    filtredResultData() {
      return this.supportFilters.resultData.filter((el) => {
        return el.name
          .toLowerCase()
          .match(this.filters.studentName.toLowerCase());
      });
    },
    saveResult(data) {
      this.axios
        .post("api/grades", {
          student_id: data.id,
          bill_id: this.filters.group,
          grade: data.finalGrades,
        })
        .then((res) => {
          if (res.data.status === false) {
            this.notify(false, "Ошибка записи");
          } else {
            this.notify(true, "Запись сохранена");
          }
        });
    },
    runFilter() {
      this.fethTresults("api/grades", { bill_id: this.filters.group });
    },
    changeDiscipline(v) {
      this.supportFilters.groupList = this.supportFilters.disciplineList.find(
        (el) => el.discipline_id === v
      ).groups;
      this.filters.group = "";
    },
    fethTresults(path, obj) {
      this.axios.get(path, obj ? { params: obj } : "").then((res) => {
        if (!obj)
          return (this.supportFilters.disciplineList = res.data.disciplines);

        this.supportFilters.gradeList = res.data.gradeList;
        this.supportFilters.resultData = res.data.result;
      });
    },
  },
  mounted() {
    this.fethTresults("api/grades");
  },
};
</script>

<style lang="scss">
.tgrade {
  .empty-result {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  display: grid;
  grid-template-rows: max-content max-content 1fr;
  height: 100%;
  row-gap: 20px;
  overflow: hidden;
  .tgrade__filters {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-auto-rows: max-content max-content;
    column-gap: 20px;
    row-gap: 20px;
  }
  .filters-top {
    width: max-content;
  }
  .filters-right {
    row-gap: 20px;
    column-gap: 20px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
  .tgrade__table {
    display: grid;
    grid-template-rows: max-content 1fr;
    height: 100%;
    overflow: hidden;
    color: $regular-text-clr;
  }
  .row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    justify-items: center;
    border-bottom: 1px solid $placeholder-text-clr;
  }
  .row-notify {
    grid-template-columns: 30px 1fr;
    font-weight: bold;
    color: $warning-clr;
    font-size: 20px;
    i {
      color: $warning-clr;
      font-size: 25px;
    }
  }
  .text-notify {
    width: 100%;
    text-align: left;
  }
  .table-header {
    font-weight: bold;
  }
  .table__body {
    overflow-y: auto;
  }
  .result__list {
    row-gap: 10px;
    display: grid;
    column-gap: 15px;
  }
  .tgrade__filters-wrp {
    row-gap: 10px;
    display: grid;
    grid-template-columns: 1fr;
    span {
      color: $regular-text-clr;
    }
  }
  .tgrade__filters-wrp:first-child {
    align-self: flex-start;
  }
  .el-button {
    height: max-content;
    align-self: flex-end;
  }
}
.el-select-dropdown {
  max-width: 1000px;
}
@media (max-width: 800px) {
  .tgrade {
    .tgrade__filters {
      grid-template-columns: 1fr;
    }
  }
}
</style>